"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "porto-recanati": {
    "46963c53": [{
      "hkey": "d7d85748",
      "slug": "porto-recanati",
      "name": "Porto Recanati",
      "primary": true,
      "skipSearch": false
    }],
    "quartiere-centro-castelnuovo-san-marino": [{
      "hkey": "d7d85748",
      "slug": "porto-recanati",
      "name": "Porto Recanati",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "16e54b27": [{
      "hkey": "d7d85748",
      "slug": "porto-recanati",
      "name": "Porto Recanati",
      "primary": true,
      "skipSearch": false
    }],
    "quartiere-nord-scossicci": [{
      "hkey": "d7d85748",
      "slug": "porto-recanati",
      "name": "Porto Recanati",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c3e1c20b": [{
      "hkey": "d7d85748",
      "slug": "porto-recanati",
      "name": "Porto Recanati",
      "primary": true,
      "skipSearch": false
    }],
    "quartiere-ovest-grotte-montarice": [{
      "hkey": "d7d85748",
      "slug": "porto-recanati",
      "name": "Porto Recanati",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f03af390": [{
      "hkey": "d7d85748",
      "slug": "porto-recanati",
      "name": "Porto Recanati",
      "primary": true,
      "skipSearch": false
    }],
    "quartiere-sud-santa-maria-in-potenza": [{
      "hkey": "d7d85748",
      "slug": "porto-recanati",
      "name": "Porto Recanati",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;